import { Injectable } from '@angular/core';
import { UtilidadesService } from '../utilidades/utilidades.servicios.index';
import { Observable } from 'rxjs';
import { SerieModel } from '../Modelo/Serie.model';

@Injectable({
    providedIn: 'root'
})
export class SeriesService {

    constructor(
        private Utilidades: UtilidadesService
    ) { }

    public Lista(): Observable<SerieModel[]> {
        return this.Utilidades.Get("Series");
    }

    public ListaPorMarca(brandId: number): Observable<SerieModel[]> {
        return this.Utilidades.Get(`Series/Marca/${brandId}`);
    }
}